import React from "react";
import ReactDOM from "react-dom";
import UploadEmployeesPage from "../components/UploadEmployeesPage";
import { displayCategoryEmployees } from "./display-category-employees";
import { showErrorMessage } from "../../commons/show-error-message";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";

export function renderUploadEmployeesPage() {
  ReactDOM.render(
    <UploadEmployeesPage />,
    document.getElementById("page-container")
  );
}

export async function displayUploadEmployeesPage(currentPage, state = null) {
  try {
    let currentPageError = 0;
    let currentPageWarning = 0;
    let currentPageUpload = 0;
    if (state === "upload") {
      currentPageUpload = currentPage;
    } else if (state === "error") {
      currentPageError = currentPage;
    } else if (state === "warning") {
      currentPageWarning = currentPage;
    }

    renderUploadEmployeesPage();

    displayCategoryEmployees({
      category: "error",
      currentPage: currentPageError,
    });

    displayCategoryEmployees({
      category: "warning",
      currentPage: currentPageWarning,
    });

    displayCategoryEmployees({
      category: "uploading",
      currentPage: currentPageUpload,
    });

    addContextLog("info", "displayUploadEmployeesPage", "display-screen");
  } catch (e) {
    logError(
      e,
      `Error to displayUploadEmployeesPage in page ${currentPage}, and state ${state}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
